import { render, staticRenderFns } from "./SDropPanel.vue?vue&type=template&id=2276820e"
import script from "./SDropPanel.vue?vue&type=script&lang=js"
export * from "./SDropPanel.vue?vue&type=script&lang=js"
import style0 from "./SDropPanel.vue?vue&type=style&index=0&id=2276820e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports